import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  signIn(options, data) {
    const response = Api().post(apiPath.login, data, options);
    return response;
  },

  register(options, data) {
    const response = Api().post(apiPath.register, data, options);
    return response;
  },

  sendCode(options, data) {
    const response = Api().post(apiPath.sendCode, data, options);
    return response;
  },

  userInfo(options, data) {
    const response = Api().post(apiPath.userInfo, data, options);
    return response;
  },

  updateUser(options, data) {
    const response = Api().post(apiPath.updateUser, data, options);
    return response;
  },

  forgotPassword(options, data) {
    const response = Api().post(apiPath.forgotPassword, data, options);
    return response;
  },

  changePassword(options, data) {
    const response = Api().post(apiPath.changePassword, data, options);
    return response;
  },

  toggleLanguage(options) {
    const response = Api().post(apiPath.toggleLanguage, null, options);
    return response;
  }
};
